import { commercialTaskFields } from './commercialTaskFields.js'
import { getOperacaoCommercialTask, updateActivity } from '../db/api.js'

export const readCommercialTask = getOperacaoCommercialTask
export async function updateCommercialTask(id, fields) {
  const updated = await updateActivity(id, commercialTaskFields(fields))
  // A resposta da própria gravação é suficiente mesmo se a leitura posterior falhar.
  return { ...updated, status: updated.status === 'feito' ? 'concluido' : 'aberto',
    assignee_ids: updated.responsavel_id ? [updated.responsavel_id] : [],
    ...(Object.hasOwn(fields, 'data_inicio') ? { data_inicio: fields.data_inicio } : fields.prazo ? { data_inicio: fields.prazo } : {}),
    concluido_at: null }
}
